import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "solid final",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M42.81 32.01c0-6.08-3.52-13.55-5.89-17.89l-2.11-3.57a10.411 10.411 0 0 1-.23 4.11 8.972 8.972 0 0 1-2.06 3.13 17.676 17.676 0 0 0-2.65-8.74c-.31-.46-1.1-1.713-1.98-2.83A21.9 21.9 0 0 0 21.57.75a15.563 15.563 0 0 1 1.51 5.63c-.07 2.3-.8 3.68-4.25 8.18s-2.6 11.21-2.6 11.21a13.647 13.647 0 0 0-1.12-2.7c-.9-1.75-4.57-3.81-4.8-3.93.1.25 1.75 4.36-.5 7.15-2.86 3.57-5.15 6.23-4.52 11.57.8 6.79 8.53 8.69 12.08 9.2h.01c1.07.16 1.75.19 1.75.19-2.337-.8-3.669-3.74-3.853-5.357a6.454 6.454 0 0 1 1.48-5.193c.476-.652 2.235-2.4 2.827-3a9.447 9.447 0 0 0 3.082-5.109 14.986 14.986 0 0 0 .129-4.216 13.209 13.209 0 0 1 4.083 4.086 8.506 8.506 0 0 1 1.307 4.3 4.453 4.453 0 0 0 1.015-1.546 5.138 5.138 0 0 0 .109-2.037s4.056 5.6 3.942 10.576c-.143 6.236-4 7.493-4.006 7.5.041-.01 13.565-1.696 13.565-15.244z"
    }, null, -1)
  ])))
}
export default { render: render }